import {fromJS} from 'immutable';
import {generatePlaceholderMessage} from '../../Helpers/utils'
import {
  STARTING_COMPLETION,
  RECEIVE_TEXT_STREAM,
  SET_ANIMATION,
  SET_END_OF_STREAM,
  SET_PLACEHOLDER_MESSAGE,
  GET_GENERAL_META_DATA_RESULT,
  RECEIVE_TEXT_STREAM_REFLECTED,
  SET_END_OF_STREAM_REFLECTED,
  SET_SHOULD_FOCUS_SEND_BUTTON,
  SET_SHOULD_FOCUS_INPUT_FIELD,
  SET_NETWORK_SPEED,
  CHAT,
  REFLECTED_CHAT,
  ANIMATION,
  GENERAL_META_DATA,
  BOT_NAME,
  PLACE_HOLDER_MESSAGE,
  SESSION_ID,
  SHOULD_FOCUS_SEND_BUTTON,
  SHOULD_FOCUS_INPUT_FIELD,
  NETWORK_SPEED,
  IS_SHOWING_NETWORK_STATS,
  NETWORK_USAGE,
  SET_NETWORK_USAGE,
  SET_IS_SHOWING_NETWORK_STATS,
  LAST_INITIATOR,
  USER_PROMPT_PREFIX, USER_PROMPT_SUFFIX,
} from './consts'

const initialState = fromJS({
  [CHAT]: [],
  [REFLECTED_CHAT]: [],
  [ANIMATION]: 0,
  [GENERAL_META_DATA]: {},
  [BOT_NAME]: '',
  [PLACE_HOLDER_MESSAGE]: generatePlaceholderMessage(),
  [SESSION_ID]: null,
  [SHOULD_FOCUS_SEND_BUTTON]: false,
  [SHOULD_FOCUS_INPUT_FIELD]: false,
  [NETWORK_SPEED]: null, // { uploadMbps, downloadMbps, measuredAt, raw? }
  [IS_SHOWING_NETWORK_STATS]: false,
  [NETWORK_USAGE]: null,
  [LAST_INITIATOR]: null,
})

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  let word, predictionUUID, endOfStream, meta, topN, selectedTopNIndex, isTopNPanelOpen

  switch (action.type) {
    case STARTING_COMPLETION:
      const prompt = USER_PROMPT_PREFIX+action.prompt.trim()+USER_PROMPT_SUFFIX
      const initiator = action.initiator
      const timestamp = Date.now()
      return state.update(CHAT, chat => chat.push(fromJS({role: 'user', text: prompt, startedAt: timestamp})))
        .update(REFLECTED_CHAT, chat => chat.push(fromJS({role: 'user', text: prompt, startedAt: timestamp})))
        .set(LAST_INITIATOR, initiator)

    case RECEIVE_TEXT_STREAM:
      ({word, predictionUUID,meta} = action)
      return state.update(CHAT, chat => {
        const lastIndex = chat.findLastIndex(entry => entry.get('predictionUUID') === predictionUUID);
        meta.forEach(item => {
          item.index = lastIndex === -1 ? 0 : chat.get(lastIndex).get('text').length
        });
        if (lastIndex !== -1) {
          return chat.update(lastIndex, entry =>
            entry.set('text', entry.get('text') + word)
              .set('meta', entry.get('meta').concat(meta)))
        } else {
          return chat.push(fromJS({role: 'assistant', text: word, predictionUUID, meta, startedAt: Date.now()}));
        }
      })

    case RECEIVE_TEXT_STREAM_REFLECTED:
      ({word = '', predictionUUID, meta, topN = null, selectedTopNIndex = -1, isTopNPanelOpen = null} = action)
      return state.update(REFLECTED_CHAT, reflectedChat => {
        const lastIndex = reflectedChat.findLastIndex(entry => entry.get('predictionUUID') === predictionUUID);
        if (lastIndex !== -1) {
          return reflectedChat.update(lastIndex, entry => {
            entry = entry.set('text', entry.get('text') + word)
            entry = entry.set('meta', meta)
            if (topN) entry = entry.set('topN', topN)
            if (selectedTopNIndex>-1) entry = entry.set('selectedTopNIndex', selectedTopNIndex)
            if (isTopNPanelOpen!==null) entry = entry.set('isTopNPanelOpen', isTopNPanelOpen)
            return entry
          })
        } else {
          return reflectedChat.push(fromJS({role: 'assistant', text: word, predictionUUID, meta, topN, isTopNPanelOpen, selectedTopNIndex, startedAt: Date.now()})).set(ANIMATION, 0)
        }
      }).set(ANIMATION, 0)

    case SET_ANIMATION:
      return state.set(ANIMATION, action.payload)

    case SET_END_OF_STREAM:
      ({endOfStream, predictionUUID} = action)
      return state.update(CHAT, chat => {
        const index = chat.findIndex(entry => entry.get('predictionUUID') === predictionUUID);
        if (index !== -1) {
          return chat.update(index, entry => entry.set('endOfStream', endOfStream));
        }
        return chat;
      })

    case SET_END_OF_STREAM_REFLECTED:
      ({endOfStream, predictionUUID} = action)
      return state.update(REFLECTED_CHAT, chat => {
        const index = chat.findIndex(entry => entry.get('predictionUUID') === predictionUUID);
        if (index !== -1) {
          return chat.update(index, entry => entry.set('endOfStream', endOfStream));
        }
        return chat;
      })

    case GET_GENERAL_META_DATA_RESULT:
      const {botName} = action.payload
      return state.set(GENERAL_META_DATA, fromJS(action.payload))
        .set('botName', botName)

    case SET_PLACEHOLDER_MESSAGE:
      return state.set(PLACE_HOLDER_MESSAGE, action.message)

    case SET_SHOULD_FOCUS_SEND_BUTTON:
      return state.set(SHOULD_FOCUS_SEND_BUTTON, action.shouldFocus)

    case SET_SHOULD_FOCUS_INPUT_FIELD:
      return state.set(SHOULD_FOCUS_INPUT_FIELD, action.shouldFocus)

    case SET_NETWORK_SPEED:
      return state.set(NETWORK_SPEED, fromJS(action.networkSpeed))

    case SET_NETWORK_USAGE:
      return state.set(NETWORK_USAGE, fromJS(action.usage))

    case SET_IS_SHOWING_NETWORK_STATS:
      return state.set(IS_SHOWING_NETWORK_STATS, !!action.isShowing)

    default:
      return state;
  }
}
;
